import request from '@/utils/request'

export function getOpenClass() {
  return request({
    url: 'hozoor/GetOpenClass',
    method: 'post'
  })
}

export function getClassStudents(classID, tarikh, sessionInday) {

  return request({
    url: 'hozoor/GetStudentOfClass',
    method: 'post',
    data: { classID: classID, tarikh: tarikh, SessionInDay: sessionInday }
  })
}

export function getSessionsCount(classID, tarikh) {

  return request({
    url: 'hozoor/GetSessionsCount',
    method: 'post',
    data: { classID: classID, tarikh: tarikh }
  })
}

export function saveHozoor(hozoorList, tarikh, sessionInday) {
  return request({
    url: 'hozoor/Save',
    method: 'post',
    data: { hozoorList: hozoorList, tarikh: tarikh, SessionInDay: sessionInday }
  })
}


export function getGheibat() {
  return request({
    url: 'gheibat/get',
    method: 'post'

  })
}

export function getGheibatSingle(id) {
  return request({
    url: `gheibat/getregister?regLesId=${id}`,
    method: 'post'

  })
}







